import React from 'react'
import marked from 'marked'
import TitleAndDescription from './titleAndDescr'
import ImageCarousel from './imageCarousel'
import TitleAndLinks from './titleAndLinks'
import ButtonBack from './buttonBack'
import Video from './video'
import View3d from './view3d'

const FeatureDetails = ({ feature, getTranslatedUiLabel, closeAction }) => (
  <div className="App-feature-details">
    <ButtonBack onClick={closeAction} label={getTranslatedUiLabel(18)} />
    <ImageCarousel images={feature.images} />

    <div className="App-content-container">
      <h1>{feature.title}</h1>
      <br/>

      <TitleAndDescription
        title={getTranslatedUiLabel(6)}
        description={feature.positionDescription}
      />

      { feature.type !== "museum" &&
        <TitleAndDescription
          title={getTranslatedUiLabel(7)}
          description={feature.depth}
        />
      }

      { feature.type !== "museum" &&
        <TitleAndDescription
          title={getTranslatedUiLabel(10)}
          description={feature.dating}
        />
      }

      { feature.HistoricalMap &&
        <div className="App-title-and-description">
          <h3>{getTranslatedUiLabel(19)}</h3>
          <ImageCarousel images={[feature.HistoricalMap]} />
        </div>
      }

      { feature.videos.length > 0 &&
        <div className="App-title-and-description">
          <h3>{getTranslatedUiLabel(20)}</h3>
          {feature.videos.map((v, i) => <Video key={i} {...v} />)}
        </div>
      }

      { feature.File3D &&
        <div className="App-title-and-description">
          <h3>{getTranslatedUiLabel(21)}</h3>
          <View3d file={feature.File3D} loadingLabel={getTranslatedUiLabel(22)} />
        </div>
      }

      { feature.description.length > 1 &&
        <TitleAndDescription
          title={getTranslatedUiLabel(9)}
          html={marked(feature.description)}
        />
      }

      { feature.type !== "museum" &&
        <TitleAndDescription
          title={getTranslatedUiLabel(8)}
          description={feature.accessible ? getTranslatedUiLabel(12) : getTranslatedUiLabel(13)}
        />
      }

      { feature.accessible &&
        <TitleAndDescription
          title={getTranslatedUiLabel(11)}
          description={feature.howToVisit}
        />
      }

      <TitleAndLinks
        title={getTranslatedUiLabel(15)}
        links={feature.externalLinks}
      />

      <TitleAndDescription
        title={getTranslatedUiLabel(14)}
        description={feature.bibliography}
      />
    </div>
  </div>
);

export default FeatureDetails;